import {FC, useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  activateWordpressIntegration,
  deactivateWordpressIntegration,
  fetchActiveIntegrationApp,
  getActivateIntegrationByUser,
  getIntegrationRefetchDataStatus,
  resetSelectedIntegrationData,
} from '../IntegrationSlice/IntegrationSlice'
import {Form, Button, Accordion, Card} from 'react-bootstrap'
import {isLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {ExternalProvider} from '../IntegrationSlice/Types'
import {
  fetchAsyncUserDetails,
  getAllUserDetails,
} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'

interface WordpressProps {
  selectedExternalProvider: ExternalProvider
  userData: any
}

const Wordpress: FC<WordpressProps> = ({selectedExternalProvider, userData}) => {
  const userValues = useSelector(getAllUserDetails)
  const token = userValues.tokens ? userValues.tokens.find((el: any) => el.name === 'wordpress') : null

  let userId = ''
  if (userData && userData.user) {
    if (userData.user._id !== userData.user.ownerId && !userData.user.subClientAccountId) {
      userId = userData.user.ownerId
    } else {
      userId = userData.user._id
    }
  }

  const selectedActiveIntegration = useSelector(
    getActivateIntegrationByUser(userId, selectedExternalProvider._id)
  )

  const refetch = useSelector(getIntegrationRefetchDataStatus)
  const globalLoading = useSelector(isLoading)

  const dispatch = useDispatch()

  // load data when first load
  useEffect(() => {
    dispatch(resetSelectedIntegrationData)
    dispatch(fetchActiveIntegrationApp())
  }, [])

  useEffect(() => {
    if (refetch) {
      // console.debug(`[integrationPageDetail] refetch for call recall data`)
      dispatch(fetchActiveIntegrationApp())
    }
  }, [refetch])

  // handle delete
  const [isOpenDeleteConfirmation, setIsOpenDeleteConfirmation] = useState(false)
  const [isDeleteConfirm, setIsDeleteConfirm] = useState(false)

  const onClickDeactivateHandler = () => {
    setIsOpenDeleteConfirmation(true)
  }

  const onClickActivateHandler = () => {
    dispatch(activateWordpressIntegration()).then(() => {
      dispatch(fetchActiveIntegrationApp())
      dispatch(resetSelectedIntegrationData)
      dispatch(fetchAsyncUserDetails())
    })
  }

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenDeleteConfirmation}
        handleClose={() => setIsOpenDeleteConfirmation(false)}
        Message={'Are you sure, you want to deactivate integration ?'}
        confirm={() => setIsDeleteConfirm(true)}
        confirmBtnTitle='Yes, deactivate'
      />
    ),
    [isOpenDeleteConfirmation]
  )

  useEffect(() => {
    if (isDeleteConfirm == true) {
      dispatch(deactivateWordpressIntegration()).then(() => {
        dispatch(fetchAsyncUserDetails())
        dispatch(resetSelectedIntegrationData)
        dispatch(fetchActiveIntegrationApp())
      })

      setIsDeleteConfirm(false)
      setIsOpenDeleteConfirmation(false)
    }
  }, [isDeleteConfirm])

  return (
    <div className='card p-7 pb-lg-4 p-lg-10'>
      {confirmation}
      <h1>Detail Integration</h1>
      <div className='row'>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
            <div className='me-7 mb-4'>
              <div
                className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'
                style={{
                  backgroundColor: '#f5f8fa',
                  borderColor: '#f5f8fa',
                  borderRadius: 5,
                  paddingLeft: 5,
                  paddingRight: 5,
                  borderWidth: 1,
                }}
              >
                {selectedExternalProvider?.image == '' || selectedExternalProvider == undefined ? (
                  <span
                    className='squere1'
                    style={{
                      width: '100px',
                      height: '100px',
                    }}
                  >{`${
                    selectedExternalProvider?.name !== undefined &&
                    selectedExternalProvider?.name !== ''
                      ? selectedExternalProvider?.name.split('')?.[0]?.toUpperCase() ?? 'C'
                      : 'EP'
                  }`}</span>
                ) : (
                  <img src={selectedExternalProvider.image} alt='wordpress' />
                )}
                <div
                  className={`position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-4 border-white h-20px w-20px ${
                    selectedActiveIntegration ? ' bg-success ' : 'bg-danger'
                  }`}
                ></div>
              </div>
            </div>
            <div className='flex-grow-1'>
              <span className='text-gray-800 fs-2 fw-bolder me-1 mb-10'>
                {selectedExternalProvider?.name ?? 'Undefined'}
              </span>
              {selectedActiveIntegration ? (
                <div className='mt-5'>
                  <Form.Group className='mb-10'>
                    <Form.Label>Api Key Label</Form.Label>
                    <Form.Control
                      type='text'
                      disabled
                      value={selectedActiveIntegration?.internalApiKeyName}
                    />
                  </Form.Group>
                  <Form.Group className='mb-10'>
                    <Form.Label>Api Key </Form.Label>
                    <Form.Control as='textarea' rows={3} disabled value={token?.token || ''} />
                  </Form.Group>

                  <Accordion className='mb-10'>
                    <Accordion.Item eventKey='0'>
                      <Accordion.Header>Integration Step</Accordion.Header>
                      <Accordion.Body>
                        <div className='row mb-10'>
                          <div className='mb-5' style={{fontSize: 14}}>
                            <ol>
                              <li>Wordpress SMS Instalation</li>
                              <a href='https://wordpress.org/plugins/wp-sms/#installation'>
                                https://wordpress.org/plugins/wp-sms/#installation
                              </a>
                              <li>Copy Api Key </li>
                            </ol>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  <Button
                    variant='danger'
                    type='submit'
                    disabled={globalLoading}
                    onClick={() => onClickDeactivateHandler()}
                  >
                    {globalLoading ? (
                      <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                    ) : (
                      'Deactivate'
                    )}
                  </Button>
                </div>
              ) : (
                <div className='mt-20'>
                  <Button
                    variant='primary'
                    type='button'
                    disabled={globalLoading}
                    onClick={() => onClickActivateHandler()}
                  >
                    {globalLoading ? (
                      <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                    ) : (
                      'Activate'
                    )}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {Wordpress}
